/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, IconButton, InputAdornment, Modal, Stack, styled, Typography } from '@mui/material';
import { Image } from '../elements/Image';
import React, { ChangeEvent, Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { TableCustom } from '../elements/TableCustom';
import { PagingInfo } from 'types/paging';
import { AssetIssues, IOptions, Room, SubmittedPhoto, TypePhotoSubmit } from 'types/room';
import {
  CUSTOMER_ATTRIBUTES,
  HEADER_ISSUES_MANAGEMENT,
  HEADER_REPORT,
  HEADER_REPORT_PREVIEW,
  headerTabAssetIssues,
  ROOM_LEVEL_ISSUES
} from 'const/room';
import { AssetPoint, ImageCustomSvg } from '../elements/ImageCustomSvg';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ButtonCustom } from '../elements/ButtonCustom';
import { InputText } from '../elements/InputText';
import { InputSelect, SelectOptions } from '../elements/InputSelect';
import {
  renderCustomAttributes,
  renderDataComplianceIssue,
  renderRoomLevelIssues,
  renderTableIssueManagement
} from './tableContent';
import { Report } from 'types/report';
import { DialogConfirm } from '../elements/DialogConfirm';
import {
  ContentExtraTableValidation,
  FormEditSubmittedEntries
} from '../../pages/ValidationsPage/components/elements/ContentExtraTableValidation';
import { useFlash } from 'contexts/flash';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { archiveSubmittedEntries, updateSubmittedEntries } from 'services/asset';
import { useAuth } from 'contexts/auth';
import { Role } from 'const/common';
import { SelectChangeEvent } from '@mui/material/Select';
import { TabsCustom } from '../elements/TabsCutom';
import { updateLongLat, updateReportArchiveIssues, updateSubmitAsset } from 'services/locations';
import { TypeEditAssetForm } from '../../pages/ValidationsPage/components/elements/EditAssetForm';
import { AssetValidationExpandedContent } from '../../pages/ValidationsPage/components/modules/AssetValidation/AssetValidationExpandedContent';
import { useFetchDocumentationWeb } from 'hooks/useGetDocuments';
import { differenceBy, lowerCase, startCase, uniqBy } from 'lodash';
import { uploadDocumentsOption } from 'services/inspections';
import { useGetDocumentOption } from 'hooks/useGetDocumentOption';
import {
  appendDynamicOptionForPayload,
  appendDynamicSingleForPayload,
  formatName,
  resolveInspectionLocationPatchIds
} from 'utils/convertData';
import { FrequencySelector, TOnupdateRoom } from './FrequencySelector';
import { ListOptions } from 'app/pages/RoomReportViewPhotoPage/hook';
import RoomLevelIssue from './RoomLevelIssue';
import MaintainenceFilter from '../elements/MaintenanceFilter';
import { FilterBar, FilterField } from '../elements/FilterBar';
import RoomPhoto from './RoomPhoto';
import { TabArchivedPhotos } from './TabArchivedPhotos';
import { SearchType } from 'types/loctions';
import { useFetchManufactures, useInsertOptionManufacturer } from 'store/manufacture';
import { useFetchTriggerSubTypes } from 'store/triggerSubType';
import { useFilteredRoomContext } from 'hooks/useFilteredRoomContext';
import { buildSingleAssetReportPayload, submitReportGeneration } from 'utils/reportGeneration';
type ComponentRoomPageProps = {
  pagingInfo: PagingInfo;
  pagingInfoTabIssues: PagingInfo;
  handleChangePage: (value: number) => void;
  handleSort: (orderBy: string) => void;
  sortOption: { field?: string; order?: string };
  room: Room;
  assetIssues?: AssetIssues[];
  dataTableReports?: Report[];
  updateLogoAsset?: (value: {
    submitId: number;
    submittedPhotoId?: number;
    additionalPhotoId?: number;
    file?: File;
    assets: AssetPoint[];
  }) => void;
  setOpenModalGenerateReport: (value: boolean) => void;
  onSearch?: (valueSearch: string) => void;
  onFilterAssetType?: (valueFilter: string) => void;
  valueFilterAssetType?: string;
  optionFilterAssetType?: SelectOptions[];
  handleFetchMore: () => void;
  hasMore: boolean;
  optionFilterAssetIssue?: AssetIssues[];
  handleRefresh?: () => Promise<AssetIssues[]>;
  handleRefreshReport?: () => void;
  setOpenModalAddAppendix?: (value: boolean) => void;
  isIssues?: boolean;
  handleSetImageSelected: (value: { id: number; key: string }) => void;
  imageSelected?: { id: number; key: string };
  setAssetIssues?: (value: AssetIssues[]) => void;
  handleDeleteAsset?: (idAsset: AssetIssues) => void;
  archiveFilter?: string;
  setArchiveFilter: (value: string) => void;
  setIssuesStatus: (value: string) => void;
  issuesStatus: string;
  tabTable: number;
  searchTextAsset: string;
  searchTextIssues: string;
  setTabTable: (value: number) => void;
  setReports: (value: Report[]) => void;
  archiveReportFilter: string;
  setArchiveReportFilter: (value: string) => void;
  frequencyOptions?: ListOptions;
  onUpdateRoom?: TOnupdateRoom;
  onFilterCriticality: (criticalityValue: SelectChangeEvent<unknown>) => void;
  selectedCriticality: string;
  filterAssets?: { key: string; value: string; label: string; level?: number }[];
  handleFilterAssets: (value?: {
    key: string;
    value: string;
    label: string;
    level?: number;
  }) => void;
  setOpenAssetForm: (value: boolean) => void;
  maintainanceSelectedDate?: string;
  maintainanceSelectedType: string;
  setSelectedMaintainanceDate: (value: string) => void;
  setSelectedMaintainanceType: (value: string) => void;
  searchType: SearchType;
  setSearchType: React.Dispatch<React.SetStateAction<SearchType>>;
  reFreshRoomLevelIssues: () => void;
  /** Submitted asset id for expanded row (URL-synced on Room page Assets tab). */
  roomAssetExpandedSubmittedAssetId?: number;
  onRoomAssetExpandedSubmittedAssetChange?: (submittedAssetId: number | undefined) => void;
};
export const ComponentRoomPage = ({
  pagingInfo,
  handleChangePage,
  handleSort,
  sortOption,
  room,
  assetIssues,
  updateLogoAsset,
  setOpenModalGenerateReport,
  onSearch,
  handleRefresh,
  handleRefreshReport,
  dataTableReports,
  optionFilterAssetIssue,
  handleSetImageSelected,
  imageSelected,
  setOpenModalAddAppendix,
  setAssetIssues,
  archiveFilter,
  setArchiveFilter,
  handleDeleteAsset,
  tabTable: tab,
  setTabTable: setTab,
  pagingInfoTabIssues,
  searchTextAsset,
  searchTextIssues,
  archiveReportFilter,
  setArchiveReportFilter,
  setIssuesStatus,
  issuesStatus,
  frequencyOptions = [],
  onUpdateRoom,
  selectedCriticality,
  onFilterCriticality,
  filterAssets,
  handleFilterAssets,
  maintainanceSelectedType,
  maintainanceSelectedDate,
  setSelectedMaintainanceType,
  setSelectedMaintainanceDate,
  reFreshRoomLevelIssues,
  setOpenAssetForm,
  searchType,
  setSearchType,
  roomAssetExpandedSubmittedAssetId,
  onRoomAssetExpandedSubmittedAssetChange
}: ComponentRoomPageProps) => {
  const insertOptionManufacturer = useInsertOptionManufacturer();

  const [rowActive, setRowActive] = useState<AssetIssues | undefined>(undefined);
  const [idActiveRow, setIdActiveRow] = useState<number | undefined>(undefined);
  const [previewGenerate, setPreviewGenerate] = useState<AssetIssues | undefined>(undefined);

  /** Keep table expand in sync with URL-driven id (Room Assets tab) and reset when id cleared. */
  useEffect(() => {
    if (roomAssetExpandedSubmittedAssetId == null) {
      setIdActiveRow(undefined);
      setRowActive(undefined);
      return;
    }
    const list = assetIssues ?? [];
    const idx = list.findIndex((a) => a.id === roomAssetExpandedSubmittedAssetId);
    if (idx >= 0) {
      const row = list[idx];
      setIdActiveRow(idx);
      setRowActive(row);
      if (row?.model?.manufacturer?.id)
        insertOptionManufacturer({
          label: row.model.manufacturer.name,
          value: row.model.manufacturer.id.toString()
        });
    } else {
      setIdActiveRow(undefined);
      setRowActive(undefined);
    }
  }, [roomAssetExpandedSubmittedAssetId, assetIssues, insertOptionManufacturer]);

  const fetchManufactures = useFetchManufactures();
  useEffect(() => {
    fetchManufactures();
  }, [fetchManufactures]);

  // Needed to resolve triggerSubTypeId ids to display names in EditAssetForm/AssetEntry
  const fetchTriggerSubTypes = useFetchTriggerSubTypes();
  useEffect(() => {
    fetchTriggerSubTypes();
  }, [fetchTriggerSubTypes]);
  const { clientId, locationId } = useParams();
  const { pathname } = useLocation();
  const {
    systemDropdownValues: options,
    singleEntryField,
    listOption
  } = useFilteredRoomContext(clientId);
  const { asyncAddDocument } = useFetchDocumentationWeb();

  const { setFlash } = useFlash();
  const [valueSearch, setValueSearch] = useState<string>('');
  const navigate = useNavigate();
  const urlFilter = useMemo(() => {
    if (!room)
      return { outside: { url: '', type: '' }, internal: { url: '', type: '' }, walls: [] };

    const wallsMap: Record<string, SubmittedPhoto[]> = {};

    const result = room.submittedPhotos.reduce(
      (acc, photo) => {
        switch (photo.type) {
          case TypePhotoSubmit.OUTSIDE:
            acc.outside = { url: photo.url, type: photo.storage.type };
            break;
          case TypePhotoSubmit.INTERNAL:
            acc.internal = { url: photo.url, type: photo.storage.type };
            break;
          default:
            if (photo.type.startsWith('WALL')) {
              const name = photo.type.toLowerCase();
              if (!wallsMap[name]) {
                wallsMap[name] = [];
              }
              wallsMap[name].push(photo);
            }
            break;
        }
        return acc;
      },
      {
        outside: { url: '', type: '' },
        internal: { url: '', type: '' },
        walls: [] as { name: string; photos: SubmittedPhoto[] }[]
      }
    );

    // Convert wallsMap to walls array
    result.walls = Object?.entries(wallsMap)
      ?.map(([name, photos]) => ({
        name,
        photos
      }))
      ?.sort((a, b) => a.name.localeCompare(b.name));

    return result;
  }, [room]);

  const { auth } = useAuth();
  const isCanAction = useMemo(
    () => (auth?.role ? [Role.ADMIN, Role.SUPER_ADMIN].includes(auth?.role) : false),
    [auth?.role]
  );
  const { documentOptions, modelFiles, setDocumentOptions } = useGetDocumentOption(rowActive);

  const mapOptions = useMemo(() => {
    const map = new Map();
    options?.forEach((op) => {
      map.set(op.id.toString(), op);
    });
    return map;
  }, [options]);

  const issuesOptions = useMemo(() => {
    const assetIssuesOptions: Record<string, string> = {};
    rowActive?.options?.forEach((assetOption) => {
      if (assetOption.fieldType === 'DROPDOWN') {
        options?.forEach((dropdownValue) => {
          const hasAssetType = dropdownValue.id.toString() === assetOption.type;

          if (hasAssetType) {
            const index = dropdownValue.dropdownValues.some(
              (dropdown) => dropdown.value === assetOption.value
            );

            assetIssuesOptions[`option_${assetOption?.type}`] = index
              ? assetOption?.value
              : 'OTHER';
            assetIssuesOptions[`option_${assetOption?.type}_name`] = assetOption?.value;
          }
        });
      } else {
        assetIssuesOptions[`single_${assetOption?.type}`] = assetOption?.value;
      }
    });
    return assetIssuesOptions;
  }, [rowActive?.options, options]);
  const onEditSubmittedEntries = useCallback(
    async ({ value, rowActive }: { value: FormEditSubmittedEntries; rowActive: AssetIssues }) => {
      try {
        if (!rowActive?.id || !rowActive?.submitId) return;
        const data = (await updateSubmittedEntries({
          id: rowActive?.id,
          submitId: rowActive?.submitId,
          payload: {
            name: rowActive.name,
            typeId: rowActive.type.id,
            condition: rowActive.condition,
            criticalityKey: rowActive.criticalityKey || '',
            validated: true,
            hasIssue: rowActive.hasIssue,
            make: rowActive.make,
            modelId: rowActive.model.id,
            altText: rowActive.altText,
            entries:
              value.fields?.map((item) => ({
                value: item.value || '',
                fieldId: item.fieldId,
                dropdownValueId: item.dropdownValueId,
                dropdownOtherValue: item.dropdownOtherValue,
                deleteDropdownId: item.deleteDropdownId
              })) || []
          }
        })) as { submittedAsset: AssetIssues };

        setFlash({ type: 'success', message: 'Updated successful' });
        const newAsset =
          assetIssues?.map((item) => {
            if (item.id === data.submittedAsset.id) {
              return {
                ...item,
                ...data.submittedAsset,
                validated: data.submittedAsset.validated ?? true,
                submittedEntries: data.submittedAsset.submittedEntries ?? item.submittedEntries
              };
            }
            return item;
          }) || [];
        setAssetIssues && setAssetIssues(newAsset);
        await handleRefresh?.();
      } catch (error: any) {
        setFlash({
          type: 'error',
          message:
            error?.response?.data?.message || 'Failed to update Properties. Please try again.'
        });
      }
    },
    [assetIssues, setAssetIssues, setFlash, handleRefresh]
  );
  const { asyncCallback: asyncOnEditSubmittedEntries } = useAsyncCallback(
    onEditSubmittedEntries,
    []
  );

  useEffect(() => {
    if (tab) {
      setValueSearch(searchTextIssues);
    } else {
      setValueSearch(searchTextAsset);
    }
  }, [searchTextAsset, searchTextIssues, tab]);

  const { asyncCallback: onArchive } = useAsyncCallback(
    async (rowActive: AssetIssues) => {
      await archiveSubmittedEntries({
        submitId: rowActive.submitId,
        id: rowActive.id,
        archive: archiveFilter !== 'archived'
      });
      if (handleRefresh) {
        await handleRefresh();
      }
      setFlash({ type: 'success', message: 'Archive successful' });
    },
    [archiveFilter]
  );

  const onGenerateSingleAsset = useCallback(
    async (asset: AssetIssues) => {
      const ok = await submitReportGeneration(buildSingleAssetReportPayload(asset), setFlash);
      if (ok) {
        navigate(
          `/clients/${asset.room.client.clientName}/${asset.room.client.id}/location/${asset.room.id}/room?tab=documentation`
        );
      }
    },
    [setFlash, navigate]
  );

  const { asyncCallback: onArchiveReport } = useAsyncCallback(
    async (report: Report) => {
      await updateReportArchiveIssues({
        issuesId: Number(report?.id),
        assetId: Number(report?.submittedAsset.id),
        submitId: Number(report?.submittedAsset?.submitId),
        payload: {
          archive: archiveReportFilter !== 'archived'
        }
      });
      if (handleRefreshReport) {
        await handleRefreshReport();
      }
      setFlash({ type: 'success', message: 'Archive successful' });
    },
    [archiveFilter]
  );
  const renderData = useCallback(() => {
    return (
      <ContentExtraTableValidation
        onEditSubmittedEntries={(value) => {
          if (!rowActive) return;
          asyncOnEditSubmittedEntries({ value, rowActive });
        }}
        dataRowActive={rowActive}
        mapOptions={mapOptions}
      />
    );
  }, [rowActive, mapOptions, asyncOnEditSubmittedEntries]);

  const handleUpdateAsset = useCallback(
    async (value: TypeEditAssetForm) => {
      const removedDocuments = differenceBy(documentOptions, value.documentOptions || [], 'id');
      const removedIds = removedDocuments.map((doc) => doc.id);
      if (!rowActive?.submitId || !rowActive?.id) return;
      if (value?.uploadedFiles?.length || removedIds) {
        const data = (await uploadDocumentsOption({
          submitId: rowActive?.submitId,
          submittedAssets: rowActive?.id,
          payload: {
            files: value?.uploadedFiles,
            deleteDocumentIds: removedIds
          }
        })) as { submittedAsset: AssetIssues };
        setDocumentOptions(data.submittedAsset.documentations);
      }
      const {
        clientId,
        roomId,
        ok: patchLocationOk
      } = resolveInspectionLocationPatchIds(rowActive);
      const patchRequests: Promise<unknown>[] = [
        updateSubmitAsset({
          submitId: rowActive?.submitId,
          submittedAssetId: rowActive?.id,
          payload: {
            name: value.assetName,
            typeId: Number(value.assetType),
            assetCustomId: value?.assetCustomId || '',
            assetCustomId2: value?.assetCustomId2 || '',
            modelId: value.model === 'OTHER' ? 0 : Number(value.model),
            model: value?.modelName || '',
            criticalityKey: value.criticalityKey,
            note: value?.note,
            otherNote: value?.otherNote,
            lastMaintenance: value?.lastMaintenance || null,
            manufacturerId:
              value?.manufacturerId && value.manufacturerId !== 'OTHER'
                ? Number(value.manufacturerId)
                : undefined,
            manufacturer: value?.manufacturer,
            validated: value.validated === 'Yes',
            entries: JSON.stringify(value.entries),
            options: JSON.stringify(appendDynamicOptionForPayload(value)),
            singleFields: JSON.stringify(appendDynamicSingleForPayload(value)),
            oemAttributes: (value as any).oemAttributes?.map((attr: any) => ({
              label: attr.label,
              value: attr.value ?? '',
              isDropdown: attr.isDropdown ?? false,
              dropdownId: attr.dropdownId ?? null,
              dropdownValue: attr.dropdownValue ?? null
            })),
            maintenanceEnabled: value.maintenanceEnabled, // ← add
            assetDevices: value.maintenanceEnabled // ← add
              ? (value.assetDevices || []).map((d) => ({
                  id: d.id,
                  maintenanceTriggerType: d.maintenanceTriggerType,
                  triggerSubTypeId: d.triggerSubTypeId ? Number(d.triggerSubTypeId) : undefined,
                  frequencyType: d.frequencyType,
                  maintenanceFrequency:
                    d.frequencyType === 'INTERVAL' ? d.maintenanceFrequency : null,
                  minMaintenanceFrequency:
                    d.frequencyType === 'RANGE' ? d.minMaintenanceFrequency : null,
                  maxMaintenanceFrequency:
                    d.frequencyType === 'RANGE' ? d.maxMaintenanceFrequency : null,
                  notificationWindow: d.notificationWindow,
                  currentReadingValue: d.currentReadingValue,
                  counterSource: d.counterSource,
                  iotDeviceId: d.iotDeviceId,
                  iotDeviceName: d.iotDeviceName
                }))
              : []
          },
          newPhotos: value.newPhotos,
          archivePhotoIds: value.archivePhotoIds
        })
      ];
      if (patchLocationOk) {
        patchRequests.push(
          updateLongLat({
            submitId: rowActive?.submitId,
            lat: value?.latitude || '',
            long: value?.longitude || '',
            clientId,
            roomId,
            date: rowActive?.updatedAt
          })
        );
      }
      const [updateResult] = await Promise.all(patchRequests);
      const type = listOption?.asset_types.find((item) => String(item.id) === value.assetType);

      // Get updated photos from response or keep existing if no response
      const updatedPhotos = (updateResult as any)?.submittedAsset?.photos || rowActive.photos;

      const newAsset =
        assetIssues?.map((item) => {
          if (item.id === rowActive.id) {
            return {
              ...rowActive,
              name: value.assetName,
              validated: value.validated === 'Yes',
              photos: updatedPhotos, // Update with latest photos from server
              type: {
                id: Number(type?.id),
                name: type?.name || ''
              }
            };
          }
          return item;
        }) || [];
      setAssetIssues && setAssetIssues(newAsset);
      const data = await handleRefresh?.();
      const activeRecord = data?.find((item) => item.id === rowActive.id);
      const newRowIndex = data?.findIndex((item) => item.id === rowActive.id);
      if (activeRecord) {
        if (activeRecord?.model?.manufacturer?.id)
          insertOptionManufacturer({
            label: activeRecord?.model?.manufacturer.name,
            value: activeRecord?.model?.manufacturer?.id?.toString()
          });
        setRowActive({ ...activeRecord, photos: updatedPhotos });
        if (newRowIndex !== undefined && newRowIndex >= 0) {
          setIdActiveRow(newRowIndex);
        }
      } else {
        setRowActive(undefined);
        setIdActiveRow(undefined);
      }
      setFlash({ message: 'Action completed successfully!', type: 'success' });
    },
    [
      documentOptions,
      rowActive,
      listOption?.asset_types,
      assetIssues,
      setAssetIssues,
      handleRefresh,
      setFlash,
      setDocumentOptions,
      insertOptionManufacturer
    ]
  );

  const { asyncCallback: asyncHandleUpdateAsset } = useAsyncCallback(handleUpdateAsset, []);

  useEffect(
    () => () => {
      mapOptions.clear();
    },
    [mapOptions]
  );
  const tableRoomLevelIssueHeaders = useMemo(() => {
    const header = [...ROOM_LEVEL_ISSUES];
    let roomLevelIssuesLargestOptions: IOptions[] = [];
    room.roomLevelIssues?.forEach((issue) => {
      roomLevelIssuesLargestOptions = [...roomLevelIssuesLargestOptions, ...issue.options];
      roomLevelIssuesLargestOptions = uniqBy(roomLevelIssuesLargestOptions, 'type');
    });
    roomLevelIssuesLargestOptions?.forEach((reportOption, index) => {
      const fieldKey = mapOptions.get(reportOption?.type)?.name || reportOption?.type;
      header.splice(index, 0, {
        label: startCase(
          lowerCase(
            mapOptions.get(reportOption?.type)?.name ||
              singleEntryField?.find((item) => item?.id.toString() === String(reportOption?.type))
                ?.name ||
              reportOption?.type
          )
        ),
        key: fieldKey,
        width: 200
      });
    });
    return { headers: header, roomLevelIssuesLargestOptions };
  }, [room.roomLevelIssues, mapOptions, singleEntryField]);
  const tableReportIssueHeaders = useMemo(() => {
    const tableReportIssueHeaders = [...HEADER_ISSUES_MANAGEMENT];
    let reportLargestOptions: IOptions[] = [];
    dataTableReports?.forEach((item) => {
      reportLargestOptions = [...reportLargestOptions, ...item.options];
      reportLargestOptions = uniqBy(reportLargestOptions, 'type');
    });
    reportLargestOptions?.forEach((reportOption, index) => {
      tableReportIssueHeaders.splice(1 + index, 0, {
        label: startCase(
          lowerCase(
            mapOptions.get(reportOption?.type)?.name ||
              singleEntryField?.find((item) => item?.id.toString() === String(reportOption?.type))
                ?.name ||
              reportOption?.type
          )
        ),
        width: 200
      });
    });
    return { headers: tableReportIssueHeaders, reportLargestOptions };
  }, [dataTableReports, mapOptions, singleEntryField]);

  return (
    <WrapperContent gap={2.5}>
      <Stack flexDirection={'row'} alignItems={'flex-start'} justifyContent={'space-between'}>
        <RoomPhoto outside={urlFilter.outside} internal={urlFilter.internal} submitId={room.id} />
        <Stack flexDirection={'row'} gap={'20px'}>
          {setOpenModalAddAppendix && isCanAction && (
            <ButtonCustom
              sx={{ width: 'max-content', height: '46px', padding: '0 20px' }}
              label={'Add Appendix'}
              isSecondary
              onClick={() => setOpenModalAddAppendix(true)}
            />
          )}
          <ButtonCustom
            sx={{ width: 'max-content', height: '46px', padding: '0 20px' }}
            label={'Generate Report'}
            onClick={() => {
              document.dispatchEvent(new Event('fresh:documentgenerate'));
              setOpenModalGenerateReport(true);
            }}
          />
        </Stack>
      </Stack>

      {/* Frequency Selector */}
      <FrequencySelector
        room={room}
        frequencyOptions={frequencyOptions}
        onUpdateRoom={onUpdateRoom}
      />

      <RoomLevelIssue
        reFreshRoomLevelIssues={reFreshRoomLevelIssues}
        tableRoomLevelIssueHeaders={tableRoomLevelIssueHeaders.headers}
        optionsLargestInTable={tableRoomLevelIssueHeaders.roomLevelIssuesLargestOptions}
        getLabelField={(type: string) => mapOptions.get(type)?.name || type}
        room={room}
      />
      <WrapperFilter>
        <TextTitle>Custom Attributes</TextTitle>
        {room.customAttributes.length > 0 && (
          <TableCustom
            data={renderCustomAttributes({
              dataTable: room.customAttributes
            })}
            handleChooseRow={() => {}}
            headers={CUSTOMER_ATTRIBUTES}
            styledTableRow={{ cursor: 'default' }}
          />
        )}
      </WrapperFilter>
      {urlFilter.walls?.map((item, index) => {
        return (
          <Stack key={index} width={'100%'} minHeight={'30px'} gap={1.25} maxWidth={'1440px'}>
            <TextTitle>{formatName(item.name)}</TextTitle>
            <Stack
              gap={2.5}
              flexDirection={'row'}
              justifyContent="flex-start"
              flexWrap={'wrap'}
              alignItems="flex-start">
              {item.photos.map((photo, photoIndex) => {
                return (
                  <Fragment key={photoIndex}>
                    <ImageCustomSvg
                      initMarker={photo?.photoTags?.map((item) => ({
                        width: item.width,
                        height: item.height,
                        x: item.xAxis,
                        y: item.yAxis,
                        value: item.submittedAssetId.toString(),
                        id: item.id
                      }))}
                      isSelected={
                        imageSelected?.key === 'submittedPhotoId' && imageSelected?.id === photo.id
                      }
                      wallName={photo.type}
                      wallId={photo.storageId}
                      submittedId={photo.submitId}
                      inspectionPhotoOrderIndex={photo.orderIndex ?? photoIndex}
                      onInspectionPhotoReplaced={reFreshRoomLevelIssues}
                      onClickPhoto={() =>
                        handleSetImageSelected({ id: photo.id, key: 'submittedPhotoId' })
                      }
                      onUpdatePhotoId={(id: number) => {
                        urlFilter.walls[index].photos[photoIndex].id = id;
                      }}
                      onSavePhoto={({ assets, file }) =>
                        updateLogoAsset &&
                        updateLogoAsset({
                          assets: assets,
                          file: file,
                          submittedPhotoId: photo.id,
                          submitId: photo.submitId
                        })
                      }
                      options={optionFilterAssetIssue}
                      url={photo.url}
                    />
                  </Fragment>
                );
              })}
            </Stack>
          </Stack>
        );
      })}
      {room.additionalStructures.map((item, index) => (
        <Stack width={'100%'} minHeight={'30px'} gap={1.25} key={index} maxWidth={'1440px'}>
          <TextTitle>{item.type === 'other' ? item.name : item.type}</TextTitle>
          <Stack
            flexDirection={'row'}
            gap={2.5}
            justifyContent="flex-start"
            flexWrap={'wrap'}
            alignItems="flex-start">
            {item.additionalStructurePhotos.map((itemPhoto, photoIndex) => (
              <Fragment key={photoIndex}>
                <ImageCustomSvg
                  initMarker={itemPhoto?.photoTags?.map((item) => ({
                    width: item.width,
                    height: item.height,
                    x: item.xAxis,
                    y: item.yAxis,
                    value: item.submittedAssetId.toString(),
                    id: item.id
                  }))}
                  wallId={itemPhoto.photoId}
                  wallName={itemPhoto.structureId.toString()}
                  submittedId={item.submitId}
                  isAdditional
                  inspectionAdditionalOrderIndex={itemPhoto.orderIndex ?? photoIndex}
                  onInspectionPhotoReplaced={reFreshRoomLevelIssues}
                  isSelected={
                    imageSelected?.key === 'additionalStructurePhotoId' &&
                    imageSelected?.id === itemPhoto.id
                  }
                  onClickPhoto={() =>
                    handleSetImageSelected({ id: itemPhoto.id, key: 'additionalStructurePhotoId' })
                  }
                  onUpdatePhotoId={(id: number) => {
                    room.additionalStructures[index].additionalStructurePhotos[photoIndex].id = id;
                  }}
                  onSavePhoto={({ assets, file }) =>
                    updateLogoAsset &&
                    updateLogoAsset({
                      assets: assets,
                      file,
                      additionalPhotoId: itemPhoto.id,
                      submitId: item.submitId
                    })
                  }
                  options={optionFilterAssetIssue}
                  url={itemPhoto.url}
                />
              </Fragment>
            ))}
          </Stack>
        </Stack>
      ))}
      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <TabsCustom
          contentTab={<></>}
          tab={tab}
          headerTab={headerTabAssetIssues}
          onChangeTab={setTab}
        />
        {tab === 0 && (
          <ButtonCustom
            sx={{ width: '180px' }}
            label={'Add Assets'}
            onClick={() => {
              setOpenAssetForm(true);
            }}
          />
        )}
      </Stack>
      <WrapperFilter>
        {tab !== 2 && (
          <Stack width="100%" gap={2}>
            <Stack flexDirection="row" flexWrap="wrap" gap={1.25} alignItems="center">
              <Stack gap={1}>
                <InputText
                  startAdornment={
                    <InputAdornment position="end">
                      <IconButton>
                        <img alt={'icon-user'} src={'/icons/icon_search.svg'} width={24} />
                      </IconButton>
                    </InputAdornment>
                  }
                  placeholder={'Search'}
                  inputProps={{
                    value: valueSearch,
                    style: {
                      width: '352px',
                      minHeight: '46px',
                      height: '46px',
                      padding: 0
                    },
                    onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                      setValueSearch(event.target.value);
                    },
                    onKeyDown: (
                      event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
                    ) => {
                      if (event.key === 'Enter') {
                        onSearch && onSearch(valueSearch);
                      }
                    }
                  }}
                />
              </Stack>
              <ButtonCustom
                sx={{ width: 'max-content', height: '46px' }}
                label={'Search'}
                onClick={() => {
                  onSearch && onSearch(valueSearch);
                }}
              />
            </Stack>

            <FilterBar>
              {tab === 0 && (
                <>
                  <Box
                    sx={{
                      flex: { xs: '1 1 100%', lg: '1 1 640px' },
                      minWidth: { xs: '100%', md: 480 }
                    }}>
                    <MaintainenceFilter
                      options={options as any}
                      maintainanceSelectedType={maintainanceSelectedType}
                      maintainanceSelectedDate={maintainanceSelectedDate}
                      setMaintenanceSelectedDate={setSelectedMaintainanceDate}
                      setSelectedMaintainenceType={setSelectedMaintainanceType}
                      searchType={searchType}
                      setSearchType={setSearchType}
                      inputSelectStyle={{ minHeight: '46px', height: '46px', width: '100%' }}
                      dateStyle={{
                        height: 46,
                        input: { height: '46px', paddingTop: 0, paddingBottom: 0 }
                      }}
                    />
                  </Box>
                  <FilterField minWidth={160}>
                    <InputSelect
                      title="Criticality"
                      value={selectedCriticality}
                      onChange={onFilterCriticality}
                      options={[
                        {
                          value: '0',
                          label: 'All'
                        },
                        { value: '1', label: '1' },
                        { value: '2', label: '2' },
                        { value: '3', label: '3' },
                        { value: '4', label: '4' },
                        { value: '5', label: '5' }
                      ]}
                      sx={{ minHeight: '46px', height: '46px', padding: 0, width: '100%' }}
                      colorTitle="#226aaa"
                      placeholder={`Select Criticality`}
                    />
                  </FilterField>
                </>
              )}
              {tab === 1 && (
                <>
                  <FilterField minWidth={180}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: '#226AAA',
                        whiteSpace: 'nowrap',
                        mb: '10px'
                      }}>
                      Search Type
                    </Typography>
                    <InputSelect
                      value={searchType}
                      onChange={(e) => setSearchType(e.target.value as SearchType)}
                      options={[
                        { label: 'Partial Text', value: 'partial-text' },
                        { label: 'Full text', value: 'full-text' }
                      ]}
                      sx={{ minHeight: '46px', height: '46px', padding: 0, width: '100%' }}
                    />
                  </FilterField>
                  <FilterField minWidth={200}>
                    <InputSelect
                      value={issuesStatus}
                      placeholder={'Status'}
                      title={'Status'}
                      onChange={(e: SelectChangeEvent<unknown>) => {
                        setIssuesStatus(e.target.value as string);
                      }}
                      sx={{ minHeight: '46px', height: '46px', padding: 0, width: '100%' }}
                      options={[
                        { value: '', label: 'All' },
                        { value: 'ACTIVE', label: 'Open' },
                        { value: 'RESOLVED', label: 'Resolved' }
                      ]}
                    />
                  </FilterField>
                </>
              )}
              <FilterField minWidth={160}>
                <InputSelect
                  value={tab ? archiveReportFilter : archiveFilter}
                  placeholder={'Archive'}
                  title={'Archive'}
                  colorTitle="#226aaa"
                  onChange={(e: SelectChangeEvent<unknown>) => {
                    if (tab) {
                      setArchiveReportFilter && setArchiveReportFilter(e.target.value as string);
                      return;
                    }
                    setArchiveFilter && setArchiveFilter(e.target.value as string);
                  }}
                  sx={{ minHeight: '46px', height: '46px', padding: 0, width: '100%' }}
                  options={[
                    { value: 'archived', label: 'Archive' },
                    { value: 'active', label: 'Active' }
                  ]}
                />
              </FilterField>
            </FilterBar>
          </Stack>
        )}
        {assetIssues && tab === 0 && (
          <TableCustom
            infoStickies={[{ index: 0, leftSpace: 0, isBorder: true }]}
            isScrollX
            onSortHeader={handleSort}
            sort={sortOption}
            data={renderDataComplianceIssue({
              dataTable: assetIssues,
              indexActive: idActiveRow,
              keySearch: filterAssets,
              onClickRoom: (value?: {
                key: string;
                value: string;
                label: string;
                level?: number;
              }) => {
                handleFilterAssets(value);
              },
              onCreateNewIssue: (value) => {
                navigate(
                  `/clients/${value.room.client.clientName}/${value.room.client.id}/location/${value.room.id}/room/issues/create-issue?room-name=${encodeURIComponent(value.room.name)}&equipment-id=${encodeURIComponent(value.name)}&asset-id=${value.id}&submitted-id=${value.submitId}`
                );
              },
              onGenerateSingleAsset: onGenerateSingleAsset,
              onCollapse: ({ value, indexRow }) => {
                const collapsing = indexRow === idActiveRow;
                if (collapsing) {
                  onRoomAssetExpandedSubmittedAssetChange?.(undefined);
                  return;
                }
                if (value?.model?.manufacturer?.id)
                  insertOptionManufacturer({
                    label: value?.model?.manufacturer.name,
                    value: value?.model?.manufacturer?.id?.toString()
                  });
                onRoomAssetExpandedSubmittedAssetChange?.(value.id);
              },
              onViewIssues: (value) => {
                navigate(`${pathname}/issues/${value.issueReports[0].id}/view-photo`);
              },
              onArchive: auth?.role === Role.SUPER_ADMIN ? (value) => onArchive(value) : undefined,
              onPreviewPdf: (value) => {
                setPreviewGenerate(value);
              },
              onDeleteAsset: handleDeleteAsset,
              isCanAction
            })}
            contentExtra={
              <WrapperItemExtra sx={{ width: '100%', maxWidth: '100%', alignItems: 'flex-start' }}>
                {rowActive && (
                  <AssetValidationExpandedContent
                    rowActive={rowActive}
                    mapOptions={mapOptions}
                    options={frequencyOptions}
                    documentOptions={documentOptions}
                    modelFiles={modelFiles}
                    issuesOptions={issuesOptions}
                    onEditSubmittedEntries={asyncOnEditSubmittedEntries}
                    onSubmitAsset={asyncHandleUpdateAsset}
                    asyncAddDocument={asyncAddDocument}
                  />
                )}
              </WrapperItemExtra>
            }
            headers={HEADER_REPORT}
            handleChooseRow={() => {}}
            indexRowShowExtra={idActiveRow}
            styledTableRow={{ cursor: 'default' }}
            pagingInfo={pagingInfo}
            handleChangePage={handleChangePage}
          />
        )}
        {dataTableReports && tab === 1 && (
          <TableCustom
            isScrollX
            onSortHeader={handleSort}
            sort={sortOption}
            data={renderTableIssueManagement({
              dataTable: dataTableReports,
              optionsLargestInTable: tableReportIssueHeaders.reportLargestOptions,
              getLabelField: (type: string) => mapOptions.get(type)?.name || type,
              onView: (value) => {
                navigate(`${pathname}/issues/${value.id}/view-photo`);
              },
              onArchive:
                auth?.role === Role.SUPER_ADMIN ? (value) => onArchiveReport(value) : undefined
            })}
            contentExtra={renderData()}
            headers={tableReportIssueHeaders.headers}
            indexRowShowExtra={idActiveRow}
            styledTableRow={{ cursor: 'default' }}
            pagingInfo={pagingInfoTabIssues}
            handleChangePage={handleChangePage}
            handleChooseRow={() => {}}
          />
        )}
        {tab === 2 && (
          <TabArchivedPhotos roomId={room.roomId ?? (locationId ? Number(locationId) : NaN)} />
        )}
      </WrapperFilter>
      <DialogConfirm
        maxWidth={1200}
        isOpen={!!previewGenerate}
        onClose={() => setPreviewGenerate(undefined)}>
        <Stack
          sx={{
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            backgroundColor: '#fff',
            outline: 'none',
            padding: '20px 50px',
            gap: 2.5
          }}>
          <Typography fontSize={'18px'} fontWeight={700} color={'#226AAA'}>
            {`${previewGenerate?.room.name}`}
          </Typography>
          <Stack flexDirection={'row'} gap={'20px'}>
            <Image url={urlFilter.outside} title={'Outside Photo'} />
            <Image url={urlFilter.internal} title={'Internal Panoramic Photo'} />
          </Stack>
          <WrapperFilter maxWidth={'100%'}>
            <TextTitle>Location Level Issues</TextTitle>
            {room.roomLevelIssues.length > 0 && (
              <TableCustom
                data={renderRoomLevelIssues({
                  dataTable: room.roomLevelIssues,
                  optionsLargestInTable: tableRoomLevelIssueHeaders.roomLevelIssuesLargestOptions,
                  getLabelField: (type: string) => mapOptions.get(type)?.name || type,
                  isCanAction
                })}
                handleChooseRow={() => {}}
                headers={tableRoomLevelIssueHeaders.headers}
                styledTableRow={{ cursor: 'default' }}
                isScrollX
              />
            )}
          </WrapperFilter>
          {urlFilter?.walls?.map((item, index) => {
            return (
              <Stack key={index} width={'100%'} minHeight={'30px'} gap={1.25} maxWidth={'1120px'}>
                <TextTitle>{formatName(item.name)}</TextTitle>
                <Stack
                  gap={2.5}
                  flexDirection={'row'}
                  justifyContent="flex-start"
                  flexWrap={'wrap'}
                  alignItems="flex-start">
                  {item.photos.map((photo, photoIndex) => {
                    return (
                      <Image key={photoIndex} url={{ url: photo.url, type: photo.storage.type }} />
                    );
                  })}
                </Stack>
              </Stack>
            );
          })}
          {room?.additionalStructures.map((item, index) => (
            <Stack width={'100%'} minHeight={'30px'} gap={1.25} key={index} maxWidth={'1120px'}>
              <TextTitle>{item.type === 'other' ? item.name : item.type}</TextTitle>
              <Stack
                flexDirection={'row'}
                gap={2.5}
                justifyContent="flex-start"
                flexWrap={'wrap'}
                alignItems="flex-start">
                {item.additionalStructurePhotos.map((itemPhoto, index) => (
                  <Image key={index} url={{ url: itemPhoto.url, type: itemPhoto.photo.type }} />
                ))}
              </Stack>
            </Stack>
          ))}
          <Stack width={'1000px'}>
            {previewGenerate && (
              <TableCustom
                isScrollX
                onSortHeader={handleSort}
                sort={sortOption}
                data={renderDataComplianceIssue({
                  dataTable: [previewGenerate],
                  readOnly: true,
                  keySearch: filterAssets,
                  onClickRoom: (value?: {
                    key: string;
                    value: string;
                    label: string;
                    level?: number;
                  }) => {
                    handleFilterAssets(value);
                  },
                  onViewIssues: (value) => {
                    navigate(`${pathname}/issues/${value.issueReports[0].id}/view-photo`);
                  },
                  onCreateNewIssue: (value) => {
                    navigate(
                      `/clients/${value.room.client.clientName}/${value.room.client.id}/location/${value.room.id}/room/issues/create-issue?room-name=${encodeURIComponent(value.room.name)}&equipment-id=${encodeURIComponent(value.name)}&asset-id=${value.id}&submitted-id=${value.submitId}`
                    );
                  }
                })}
                contentExtra={renderData()}
                headers={HEADER_REPORT_PREVIEW}
                handleChooseRow={() => {}}
                indexRowShowExtra={idActiveRow}
                styledTableRow={{ cursor: 'default' }}
                handleChangePage={handleChangePage}
              />
            )}
          </Stack>
        </Stack>
      </DialogConfirm>
    </WrapperContent>
  );
};

const WrapperContent = styled(Stack)(() => ({
  width: '100%',
  margin: '20px 0',
  marginBottom: '50px'
}));
const WrapperFilter = styled(Stack)(() => ({
  width: '100%',
  gap: '10px'
}));
const TextTitle = styled(Typography)(() => ({
  color: '#226AAA',
  fontSize: '18px',
  fontWeight: 900
}));
const WrapperItemExtra = styled(Stack)(() => ({
  borderRadius: 10,
  border: '1px solid #E0E0E0',
  padding: '20px'
}));
